import React from "react";

export type AdminKpiCardProps = {
  label: string;
  value: string;
  hint?: string;
  /** Classes additionnelles sur la carte (accents RH, alertes). */
  className?: string;
};

/**
 * Carte KPI homogène (bordure, hover) — même langage visuel que le dashboard métier.
 */
export function AdminKpiCard({ label, value, hint, className = "" }: AdminKpiCardProps): React.JSX.Element {
  return (
    <article
      className={`rounded-2xl border border-slate-800 bg-slate-900/70 p-4 shadow-md transition hover:border-slate-700/90 hover:bg-slate-900/90 ${className}`}
    >
      <p className="text-[10px] font-bold uppercase tracking-widest text-slate-500">{label}</p>
      <p className="mt-2 text-2xl font-bold tabular-nums tracking-tight text-white">{value}</p>
      {hint ? <p className="mt-1 text-xs text-slate-500">{hint}</p> : null}
    </article>
  );
}
